/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { DataInfo } from './DataInfo';

export type LivewatchPlanDetailInfo = {
    CD: LivewatchPlanDetailInfo.CD;
    NM: string;
    DATA: Array<DataInfo>;
};

export namespace LivewatchPlanDetailInfo {

    export enum CD {
        INVESTORS_FUNDING = 'INVESTORS_FUNDING',
        LIQUIDITY_MANAGEMENT = 'LIQUIDITY_MANAGEMENT',
        MARKETING = 'MARKETING',
        MISCELLANEOUS = 'MISCELLANEOUS',
        TEAM_ADVISORS = 'TEAM_ADVISORS',
        TREASURY_GRANTS = 'TREASURY_GRANTS',
    }


}

